// import emoji from 'react-easy-emoji';

export const greetings = {
  name: 'Zeeshan Nasir',
  title: "Hi, I'm",
  role: 'MERN Developer',
  info: 'I transforms the UI designs into high-quality code and develop responsive, optimized and efficient websites',
  description: [
    "I'm Zeeshan Nasir, a creative and meticulous frontend developer with expertise in React.js, Next.js, and Tailwind CSS. I specialize in transforming wireframes and UI designs into highly functional, responsive, and visually engaging applications. My experience spans building scalable and efficient web applications while maintaining a keen eye for user experience and performance.",
    'I am seeking a role in a forward-thinking organization where I can contribute my skills to create impactful digital experiences, while continuously expanding my expertise and growing alongside the team.',
  ],
  profileImg: 'https://avatars.githubusercontent.com/u/57254223?v=4',
};

export const openSource = {
  githubUserName: 'zeeshannasir16',
};

export const contact = {
  email: 'm.zeeshannasir5@gmail.com',
};

export const socialLinks = {
  github: 'https://github.com/zeeshannasir16',
  linkedin: 'https://www.linkedin.com/in/zeeshannasir16',
  resume:
    'https://drive.google.com/file/d/18Pq959V_y3tpNoLtsWtoc2_f3MJuwcBM/view?usp=sharing',
};

export const skillSet = [
  {
    skillName: 'Reactjs',
    fontAwesomeClassname: 'vscode-icons:file-type-reactjs',
  },
  {
    skillName: 'Naxt.js',
    fontAwesomeClassname: 'logos:nextjs-icon',
  },
  {
    skillName: 'JavaScript',
    fontAwesomeClassname: 'logos:javascript',
  },
  {
    skillName: 'TypeScript',
    fontAwesomeClassname: 'logos:typescript-icon',
  },
  {
    skillName: 'Material UI',
    fontAwesomeClassname: 'simple-icons:mui',
  },
  {
    skillName: 'Tailwindcss',
    fontAwesomeClassname: 'logos:tailwindcss-icon',
  },
  {
    skillName: 'Firebase',
    fontAwesomeClassname: 'logos:firebase',
  },
  {
    skillName: 'Git',
    fontAwesomeClassname: 'logos:git-icon',
  },
  {
    skillName: 'Redux Toolkit',
    fontAwesomeClassname: 'logos:redux',
  },
  {
    skillName: 'HTML5',
    fontAwesomeClassname: 'vscode-icons:file-type-html',
  },
  {
    skillName: 'CSS3',
    fontAwesomeClassname: 'vscode-icons:file-type-css',
  },
  {
    skillName: 'Nodejs',
    fontAwesomeClassname: 'logos:nodejs-icon',
  },
  {
    skillName: 'ExpressJS',
    fontAwesomeClassname: 'logos:express',
  },
  {
    skillName: 'MongoDB',
    fontAwesomeClassname: 'logos:mongodb',
  },
];

export const experience = [
   {
    role: 'React Developer',
    company: 'BeyondSol',
    // companylogo: '/img/icons/common/google.svg',
    date: 'Jun 2023 – Present',
    descBullets: [
      'Developing and implementing highly-responsive user interface components using React concepts as well as translating designs to interactive, pixel perfect and responsive sites.',
      'API Integration as well as managing the data in front end codebase.'
    ],
  },
  {
    role: 'Junior Software Engineer',
    company: 'Softoo Ltd',
    companylogo: 'https://softoo.co/images/Softoo-main-logo.svg',
    date: 'March 2023 – June 2023',
    descBullets: [
      'Worked on the development of backend applications using Express.js with TypeScript, implementing key functionalities such as security, authentication, error handling, file handling, and payment processes',
      'Responsibly worked on implementing good coding practices, ensuring both functionality and security of the application',
    ],
  },
  {
    role: 'React Developer',
    company: 'Fiverr',
    // companylogo: '/img/icons/common/google.svg',
    date: 'Jul 2021 – Jan 2023',
    descBullets: [
      'Developing and implementing highly-responsive user interface components using React concepts as well as translating designs to interactive, pixel perfect and responsive sites',
    ],
  },
  {
    role: 'Software Developer (.NET Developer)',
    company: 'InterwebBytes ',

    date: 'Sep 2020 – Aug 2021',
    descBullets: [],
  },
];

export const projects = {
  collaboration: [
    {
      projectType: 'TOUR & TRAVELLING',
      name: 'GOODFLY TRAVELS',
      desc: 'A travel & tour website that makes your next trip the best it can be.  Travel packages are designed to give travellers the experience of a lifetime, every time.',
      link: 'https://example.com',
      techList: [
        'React JS',
        'Node JS',
        'Material-UI',
        'Context API',
        'Axios',
        'React Hook Form',
      ],
      status: 'completed',
      logo: 'https://i.ibb.co/gWbT5x5/white-Logo.png',
      extras: {
        color: '#46B9F6',
        screenshot: 'https://i.ibb.co/98gcPx3/goodfly.png',
      },
    },
    {
      projectType: 'Health & Wellness',
      name: 'Royal Thai Spa',
      desc: 'A multi-vendor site that offers wide range of spa related products and services of various vendors.',
      link: 'https://example.com',
      techList: [
        'React JS',
        'Node JS',
        'Material-UI',
        'Redux Toolkit',
        'Formik',
        'Yup',
        'Stripe',
      ],
      logo: 'https://i.ibb.co/xmh2hkf/spaNew.png',
      extras: {
        color: '#ff679b',
        screenshot: 'https://i.ibb.co/qNMnrpw/royalSpa.png',
        status: 'In Development',
      },
    },
    {
      projectType: 'Auctions',
      name: 'LotPot Auctions',
      desc: 'An auction marketplace where you can propose the buying and selling of any item or experience you want that you cannot get normally.',
      link: 'https://example.com',
      techList: ['React JS', 'Node JS', 'Material-UI', 'Axios', 'Stripe'],
      logo: 'https://i.ibb.co/8xsktjz/lotpot-New.png',
      extras: {
        color: '#7c7c7c',
        screenshot: 'https://i.ibb.co/dgVYccZ/screely-1650768678170.png',
      },
    },
  ],
  personal: [
    {
      name: 'Task Management App (MERN | TS)',
      desc: 'Kanban application in which project manager create and assigns task to individuals. The User then change the status of task through Kanban Board',
      repoLink: 'https://github.com/ZeeshanNasir16/task-mgt-app-frontend',
      techList: [
        'React JS',
        'TypeScript',
        'NodeJs',
        'ExpressJS',
        'MongoDB',
        'Redux-Toolkit',
        'Joi',
        'Material-UI',
        'Axios',
      ],
    },
    {
      name: 'box Cloud Storage - Clone',
      desc: 'Simple cloud storage clone built using React JS and Firebase.',
      repoLink: 'https://github.com/ZeeshanNasir16/Cloud-Storage',
      techList: ['React JS', 'Firebase', 'Material-UI', 'Axios'],
    },
    {
      name: 'Shopping Cart App',
      desc: 'Application using which the user can view and can purchase an item. The Commerce.js provides custom cart and checkout experiences with the integration of Stripe Payment API. The internal state of application is managed using react-redux.',
      repoLink: 'https://github.com/ZeeshanNasir16/Laptop-Store',
      techList: [
        'React JS',
        'Commerce.js API',
        'Material-UI',
        'Redux',
        'Stripe API',
      ],
    },
  ],
};
